import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, Menu as MenuIcons, AreaIcon, CloseIcon, WarningIcon } from 'assets/icons';
import { FormalityService, GeneralService } from 'services';
import ModalView from './modal-view';
import ModalPayment from 'components/modal-payment';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
};

class Formalities extends React.Component<Props> {
  timer: any = undefined;

  state = {
    form: INITIAL_STATE,
    formalities: [],
    areas: [],
    area_id: '',
    visible: false,
    visible_consumed: false,
    visible_payment: false,
    membership_status: Constants.ACCES_STATUS.ACCESS_DENIED,
    price: 0,
    item: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Trámites Automatizados',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    //@ts-ignore
    const area_id = this.props.history.location?.state?.area_id;

    if (area_id) {
      this.setState(
        {
          area_id,
        },
        () => {
          this.getFormalities(true);
        },
      );
    }

    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const user = this.props.user;
    const res: any = await FormalityService.get({
      user_id: user?.id,
      withoutLoading,
      ...this.state.form,
    });

    const selects: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      services: true,
      service_id: Constants.SERVICES.FORMALITIES,
    });

    this.setState({
      areas: res.areas || [],
      price: selects.services[0].price,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  getFormalities = async (withoutLoading = false) => {
    const res: any = await FormalityService.getFormalities({
      area_id: this.state.area_id,
      withoutLoading,
      user_id: this.props.user?.id,
    });
    const selects: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      services: true,
      service_id: Constants.SERVICES.FORMALITIES,
    });
    this.setState({
      formalities: res.formalities || [],
      membership_status: res.membership_status,
      price: selects.services[0].price,
    });
  };

  onClose = (reload: boolean = false) => {
    this.setState(
      {
        visible: false,
        visible_consumed: false,
        visible_payment: false,
        item: null,
      },
      () => {
        if (reload) {
          this.load(true);
          this.getFormalities();
        }
      },
    );
  };

  view = (item: any) => {
    const { membership_status } = this.state;
    if (membership_status === Constants.ACCES_STATUS.ACCESS_LIMITED) {
      return this.setState({ visible_consumed: true });
    }
    if (membership_status === Constants.ACCES_STATUS.ACCESS_GRANTED) {
      return this.setState({ visible: true, item });
    }
  };

  openModalPayment = () => {
    this.setState({
      visible_payment: true,
      visible_consumed: false,
    });
  };

  onSuccesPayment = async (data: any) => {
    try {
      const { user } = this.props;
      await GeneralService.savePayment({
        user_id: user?.id,
        service_id: Constants.SERVICES.FORMALITIES,
        ...data,
      });
      Globals.showSuccess('Se ha enviado el pago correctamente, ya puede realizar una llamada');
      this.onClose(true);
    } catch (error) {}
  };

  render() {
    const { visible, membership_status, visible_consumed, visible_payment } = this.state;

    return (
      <div id='client-formalities'>
        <Modal
          className='modal-view-formality'
          visible={visible}
          title='Apreciado usuario necesitamos que complete los siguientes datos para el llenado del formato en cuestión'
          onClose={() => this.onClose()}
        >
          {/*
		          // @ts-ignore */}
          <ModalView item={this.state.item} onClose={(reload: boolean) => this.onClose(reload)} />
        </Modal>

        <Modal
          id='modal-consumed-payment'
          visible={visible_consumed}
          title='Trámites automatizados'
          onClose={() => this.onClose()}
        >
          <img src={WarningIcon} />
          <p className='title'>Usted ha consumido el limite de tramites automatizados</p>
          <p>Puede obtener el servicio mediante pago o esperar el próximo mes</p>

          <div className='btn-container'>
            <button className='btn btn-accept' onClick={this.openModalPayment}>
              Pagar
            </button>
            <button className='btn' onClick={() => this.onClose()}>
              Cancelar
            </button>
          </div>
        </Modal>

        <Modal
          className='modal-payment-formality '
          visible={visible_payment}
          title=''
          onClose={() => this.onClose()}
        >
          {/*// @ts-ignore */}
          <ModalPayment
            onClose={(reload: boolean) => this.onClose()}
            price={this.state.price}
            onSuccess={(data: any) => this.onSuccesPayment(data)}
            title='Tramites automatizados'
          />
        </Modal>

        <div className='row'>
          <div className={`col-md-${this.state.area_id ? '6' : '12'}`}>
            <div className='container-form'>
              <div className='row row-filter'>
                <div className='col-md-12'>
                  <div className='row'>
                    <div className='col-md-5'>
                      <Input
                        value={this.state.form.search}
                        name='search'
                        placeholder='Buscar'
                        className='input-table'
                        onSubmit={() => this.load()}
                        onChange={(e: any) => {
                          clearTimeout(this.timer);
                          this.timer = setTimeout(() => {
                            this.load(true);
                          }, 1000);
                          this.change(e);
                        }}
                      />
                    </div>
                    <div className='col-md-1'>
                      {this.state.form != INITIAL_STATE && (
                        <button className='btn btn-clean' onClick={() => this.reset()}>
                          <img src={CleanIcon} />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className='container-white'>
                <div className='container-title'>
                  <div className='icon-container' style={{ backgroundColor: Colors.blue }}>
                    <img src={MenuIcons.Menu5} />
                  </div>
                  <h3>Tramites automatizados</h3>
                </div>
                {this.state.areas.map((item: any) => {
                  return (
                    <button
                      className={`btn btn-area ${item.id == this.state.area_id ? 'active' : ''}`}
                      onClick={() => {
                        this.setState(
                          {
                            area_id: item.id,
                          },
                          () => this.getFormalities(),
                        );
                      }}
                    >
                      <div className='icon-container' style={{ backgroundColor: Colors.white }}>
                        <img src={AreaIcon} />
                      </div>
                      {item.name}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          {this.state.area_id && (
            <div className='col-md-6'>
              <div className='container-blue'>
                <div className='container-title'>
                  <h3>Seleccione la plantilla de su interes</h3>
                  <button
                    className='btn btn-close'
                    onClick={() => {
                      this.setState({
                        formalities: [],
                        area_id: '',
                      });
                    }}
                  >
                    <img src={CloseIcon} />
                  </button>
                </div>
                <div className='container-white'>
                  {this.state.formalities.map((item: any) => {
                    return (
                      <button className='btn' onClick={() => this.view(item)}>
                        {item.name}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Formalities);
